import emit from '../../common/events';
import environment from '../../common/environment';
import { BaseComponent } from '../base-component/base-component';
import { addAnalyticsCheckoutFlowMetadata } from '../../common/utils/cart-util';
import { css, html } from 'lit';
import { ariaLabelWithNewTab } from '../../common/utils/a11y-util';
import { customElement, property } from 'lit/decorators.js';

/**
 * A static element to display the default checkout agreements.
 */
@customElement('mhecomm-checkout-agreements')
export class CheckoutAgreements extends BaseComponent {
  static styles = [css`
    .uxt-mhcorp {
      display: inline;
    }
  `];

  /**
   * The label to display before the legal links.
   */
  @property({type: String})
  legalCopyPrefix = 'By clicking "Place Order", I confirm that I have read and agree to the';

  renderComp() {
    return html`
      ${this.legalCopyPrefix}
      <a 
        href=${environment().termsOfUseUrl} 
        @click=${() => this.eventLegalLink("Terms of Use")} 
        target="_blank"
        aria-label="${ariaLabelWithNewTab('Terms of Use')}"
        data-automation-id="terms-of-use-link"
      >
        Terms of Use
      </a>,
      <a 
        href=${environment().videoViewingNoticeUrl} 
        @click=${() => this.eventLegalLink("Video Viewing Notice")} 
        target="_blank"
        aria-label="${ariaLabelWithNewTab('Video Viewing Notice')}"
        data-automation-id="video-viewing-notice-link"
      >
        Video Viewing Notice
      </a>,
      <a 
        href=${environment().consumerPurchaseTermsUrl} 
        @click=${() => this.eventLegalLink("Consumer Purchase Terms")} 
        target="_blank"
        aria-label="${ariaLabelWithNewTab('Consumer Purchase Terms')}"
        data-automation-id="consumer-purchase-terms-link"
      >
        Consumer Purchase Terms
      </a> and
      <a 
        href=${environment().privacyNoticeUrl} 
        @click=${() => this.eventLegalLink("Privacy Notice")} 
        target="_blank"
        aria-label="${ariaLabelWithNewTab('Privacy Notice')}"
        data-automation-id="privacy-notice-link"
      >
        Privacy Notice
      </a>.
    `;
  }

  /**
   * Emits an event when a legal link is clicked.
   *
   * @param eventName
   */
  private eventLegalLink(eventName: string) {
    emit({
      element: this,
      name: 'click',
      detail: addAnalyticsCheckoutFlowMetadata({
        eventName: eventName.toLowerCase().replace(/\s/g, '-'),
        label: eventName
      })
    })
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-checkout-agreements': CheckoutAgreements;
  }
}
